module.exports = __webpack_public_path__ + "img/order-bg.891e8a4b.png";